import React from "react";
import DriverLayout from "../../layouts/DriverLayout";
import LocationComponent from "../../components/LocationComponent";

const DriverDashboard = () => {
  return (
    <DriverLayout>
      <h2>Drver Dashboard</h2>
      <p>Welcome to the Driver panel.</p>
      <LocationComponent />
      </DriverLayout>
  );
};

export default DriverDashboard;
